
export default {
  props: {
    fill: {
      type: String,
      default: '#FFFFFF',
    },
  },
}
